import { ui } from "aaa";
import * as React from "react";
import { NativeIconButton } from "components/common/NativeIconButton";
import { IconClear } from "./primitives";

interface IProps {
    onClick?: () => void;
    showRight?: boolean;
    color?: string;
    size?: number;
    offset?: { x: number, y: number };
}

/**
 * Renders close button X in the left top corner
 * @param props 
 */
export const CancelButton = (props: IProps) => {
    let style: any = { position: "absolute", top: props.offset ? props.offset.y : 10, zIndex: 10 };
    if (props.showRight === true) {
        style.right = props.offset ? props.offset.x : 10;
    } else {
        style.left = props.offset ? props.offset.x : 10;
    }

    const iconStyle = {
        ...(props.size ? { width: props.size, height: props.size } : undefined),
        color: props.color || "#ffffff"
    };

    return (
        <NativeIconButton
            style={style}
            onClick={props.onClick}
            aria-label={ui.__("common.close")}
        >
            <IconClear style={iconStyle} />
        </NativeIconButton>
    );
};


// WEBPACK FOOTER //
// ./src/components/util/CancelButton.tsx